import { Box, Pagination } from "@mui/material";

import { DownloadTableToExcel } from "components/DownloadTableToExcel";
import { Search } from "components/ListPage/Widgets/Search";

import { i18n } from "services/i18nService";
import { columnInfo } from "services/sosInventoryService/notification/schema";
import { checkForUnexpectedProps } from "services/utility/misc";

import { BatchActions } from "views/Notifications/List/BatchActions";
import { Filters } from "views/Notifications/List/Filters";

export function Widgets(props) {
  const {
    checkedIds,
    setCheckedIds,
    setSelectAllState,
    retrievalParams,
    setRetrievalParams,
    totalRecords,
    tableRef,
    records,
    ...unexpected
  } = props;
  checkForUnexpectedProps("Widgets", unexpected);

  function pageChange(_, page) {
    setRetrievalParams((prevParams) => ({
      ...prevParams,
      startingRecord: (page - 1) * retrievalParams.maxResults + 1,
    }));
  }

  return (
    <Box
      sx={{
        displayPrint: "none",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        height: "3.5rem",
        m: "0 0.5rem",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "1rem",
        }}
      >
        <BatchActions
          checkedIds={checkedIds}
          setCheckedIds={setCheckedIds}
          setSelectAllState={setSelectAllState}
        />
        <DownloadTableToExcel
          tableRef={tableRef}
          fileName={i18n(`objectType.notification.Sentence`)}
          columnConfig={columnInfo}
          records={records}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <Search
          setRetrievalParams={setRetrievalParams}
          objectType="notification"
        />

        <Filters
          retrievalParams={retrievalParams}
          setRetrievalParams={setRetrievalParams}
        />
        <Pagination
          page={
            (retrievalParams.startingRecord - 1) / retrievalParams.maxResults +
            1
          }
          size="small"
          shape="rounded"
          siblingCount={1}
          count={Math.ceil(totalRecords / retrievalParams.maxResults)}
          onChange={pageChange}
        />
      </div>
    </Box>
  );
}
